import { get } from "@/apis";
import router from "@/router";
import { parseErrorMessage } from "@/utils/util";
import message from "ant-design-vue/lib/message";

export default {
  namespaced: true,
  state: {
    signLocationId: 0, // 选中签到点Id,加载签到点配置
    IsTheLinkValid: false,
    IsSignRenderingCompleted: false, // 签到配置信息是否渲染完成
    // 签到配置信息
    config: {
      id: 0,
      name: "",
      type: 0,
      activityId: 0,
      isLinear: false,
      isStrictLinear: false,
      isShowModal: false,
      modalTitle: "",
      modalContent: "",
      modalConfirmButtonText: "",
      modalCancelButtonText: "",
      modalConfirmButtonColor: "",
      modalCancelButtonColor: "",
      modalBackgroundColor: "",
      modalTextColor: "",
      modalConfirmButtonTextColor: "",
      modalCancelButtonTextColor: "",
      modalConfirmButtonEnterUrl: "",
      modalWindowTarget: "",
      banner: "",
      footer: "",
      systemPrimaryColor: "",
      systemInverseColor: "",
    },
  },
  mutations: {
    SET_CONFIG(state, payload) {
      state.config = payload;
    },
    SET_ACTIVITY_RENDERING_COMPLETED(state) {
      state.IsActivityRenderingCompleted = true;
    },
    SET_SIGN_RENDERING_COMPLETED(state) {
      state.IsSignRenderingCompleted = true;
    },
    SET_THE_LINK_VALID(state) {
      state.IsTheLinkValid = true;
    },
  },
  getters: {
    getConfig: (state) => {
      return state.config;
    },
    getBanner: (state) => {
      return state.config.banner || false;
    },
    getFooter: (state) => {
      return state.config.footer || false;
    },
    getIsSignRenderingCompleted: (state) => {
      return state.IsSignRenderingCompleted;
    },
    getIsTheLinkValid: (state) => {
      return state.IsTheLinkValid;
    },
  },
  actions: {
    async setConfig(context, data) {
      message.open({
        content: "配置加载中...",
        type: "loading",
        duration: 1,
      });

      const { alias } = data;
      const res = await get(`/api/CheckIn/GetGroupConfig/${alias}`);
      if (res.code === 200 && res.success) {
        document.documentElement.style.setProperty(
          "--primary-color",
          res.data.systemPrimaryColor
        );
        // 设置系统反色
        document.documentElement.style.setProperty(
          "--primary-inverse-color",
          res.data.systemInverseColor
        );
        context.commit("SET_CONFIG", res.data);
      } else {
        var pem = parseErrorMessage(res.message);
        if (!!pem) {
          router.push(`/error?title=[${pem.code}]&msg=${pem.message}`);
        }
      }
    },
    setIsSignRenderingCompleted(context) {
      context.commit("SET_SIGN_RENDERING_COMPLETED");
    },
  },
};
